// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonLaserBeam_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10 3H8V9.58515L3.3439 4.92905L1.92969 6.34326L6.58642 11L0 11V13H6.58496L1.92833 17.6566L3.34254 19.0708L8 14.4134V21H10V14.4136L14.6576 19.0712L16.0718 17.657L11.4149 13L24 13V11L11.4134 11L16.0705 6.34292L14.6562 4.92871L10 9.58496V3Z" class="svg-bg"/>
</svg>
`;
const _s48IconSvg = html `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M18 18.9558V7H16V18.9677L14.0989 14.3791L12.2512 15.1446L14.1548 19.7393L5.6875 11.272L4.27329 12.6862L12.7524 21.1653L8.13818 19.2614L7.37532 21.1102L11.9553 23H0V25H12.0334L7.39453 26.9453L8.16798 28.7897L12.6985 26.8898L4.27463 35.3137L5.68884 36.7279L14.1637 28.253L12.2617 32.8625L14.1105 33.6254L16 29.0462V41H18V29.0204L19.9062 33.6216L21.754 32.8561L19.8517 28.2646L28.3149 36.7278L29.7291 35.3136L21.2513 26.8357L25.8633 28.7388L26.6261 26.89L22.0458 25H48V23H21.9743L26.6119 21.0552L25.8384 19.2108L21.3047 21.112L29.7305 12.6863L28.3163 11.2721L19.8341 19.7542L21.7391 15.1374L19.8903 14.3746L18 18.9558Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonLaserBeam is a generated icon component.
 */
let IconCommonLaserBeam = IconCommonLaserBeam_1 = class IconCommonLaserBeam extends IconBaseElement {
    render() {
        return html `${IconCommonLaserBeam_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonLaserBeam.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s48IconSvg],
    ['s40', _s48IconSvg],
    ['s48', _s48IconSvg],
    ['s64', _s48IconSvg],
    ['s72', _s48IconSvg],
    ['s80', _s48IconSvg],
]);
IconCommonLaserBeam = IconCommonLaserBeam_1 = __decorate([
    customElement('zui-icon-common-laser-beam')
], IconCommonLaserBeam);
export { IconCommonLaserBeam };
